<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('ItemDetails.title') }}</h6>
        </div>
    </b-row>
    <b-row class="my-2 ps-3">
        <b-col sm="12" md="12" lg="12" xl="10">
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('ItemDetails.itemcode') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field">{{ dataObj.Code }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('ItemDetails.productid') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field">{{ dataObj.ProductId }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('ItemDetails.hsncode') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field">{{ dataObj.HSNCode }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('ItemDetails.descriptivename') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field">{{ dataObj.Name }}</p>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('ItemDetails.vaton') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field">Purchase price</p>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                    <label class="display-field-label">{{ $t('ItemDetails.markup') }}</label>
                </b-col>
                <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                    <p class="details-black-field">{{ dataObj.MarkupPercentage }}%</p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>
